export enum PayoutProtectionStatus {
  FullyConfigured = 'fully_configured',
  Legacy = 'legacy',
  Unsafe = 'unsafe',
}
